export default __webpack_public_path__ + "static/michigan-veteran-connector-logo-98479b19958a391fae7e34f7caa920c3.png";